import ZimssaAPI from './ZimssaAPIConfig';
import { TVerifyType, TServiceType } from './ApiTypes';
import {
  IServerResponse,
  IPartnerSignUp,
  IServiceSmallMoveTempBody,
  IServiceFamilyMoveTempBody,
  IServiceMoveCleaningTempBody,
  IServiceSmallMoveRegisterBody,
  IServiceFamilyMoveRegisterBody,
  ISerMoveCleaningRegisterBody,
  IUserProfileRegisterBody,
  IUserRegisterBody,
  IUserModifyBody,
  IDocReviewBody,
  IServiceFeatureRegisterBody,
} from './ApiInterfaces';

const API = {
  ADDRESS: '/address',
  FILEUPLOAD: '/fileupload',

  VERIFY: {
    SET: '/verify/set',
    CHECK: '/verify/check',
  },

  PARTNER: {
    SIGNUP: '/partner/signup',
    LOGIN: '/partner/login',
    LOGOUT: '/partner/logout',
    STATUS: '/partner/status',
    SURVEY_CONTENTS: '/partner/survey-contents',
  },

  SERVICE: {
    INFO: '/service/info',
    STATUS: '/service/status',
    PROGRESS: '/service/progress',
    TEMP_DATA: '/service/tempdata',
    SMALLMOVE_TEMP_SAVE: '/service/smallmove/temp/save',
    SMALLMOVE_REGISTER: '/service/smallmove/register',
    FAMILYMOVE_TEMP_SAVE: '/service/familymove/temp/save',
    FAMILYMOVE_REGISTER: '/service/familymove/register',
    MOVECLEANING_TEMP_SAVE: '/service/move-cleaning/temp/save',
    MOVECLEANING_REGISTER: '/service/move-cleaning/partner',
    INTERVIEW_ANSWER: '/service/interview-answer',
    APPROVE_CHECKED: '/service/approve-checked',
    GET_DOC_REJECT: '/service/doc-reject-info',
    DOC_REVIEW: '/service/doc-review',
    FEATURE_REGISTER: '/service/offer/register',
  },

  USER: {
    LIST: '/user/list',
    REGISTER: '/user/register',
    MODIFY: '/user/modify',
    REGISTER_PROFILE: '/user/profile/register',
    GET_PROFILE: '/user/profile',
  },
  APP_DOWN_LOAD: '/app-download',
  GET_POLICY: '/policy',
};

/**
 * 파일 업로드
 * @param data
 */
export const apiFileUpload = (data: FormData) =>
  ZimssaAPI.post(API.FILEUPLOAD, data);

/**
 * 주소 전체 조회
 */
export const apiGetAddress = (): Promise<IServerResponse> =>
  ZimssaAPI.get(API.ADDRESS);

/**
 * 인증번호 발송
 * @param phone
 * @param type
 */
export const apiVerifySet = (
  phone: string,
  type: TVerifyType
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.VERIFY.SET, {
    phone: phone,
    value: '',
    type,
  });

/**
 * 인증번호 확인
 * @param phone
 * @param authCode
 * @param type
 */
export const apiVerifyCheck = (
  phone: string,
  authCode: string,
  type: TVerifyType
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.VERIFY.CHECK, {
    phone: phone,
    value: authCode,
    type,
  });

/**
 * 파트너 가입
 * @param name
 * @param phone
 * @param authCode
 * @param birthday
 * @param subscriptionType
 */
export const apiPartnerSignUp = ({
  ...body
}: IPartnerSignUp): Promise<IServerResponse> =>
  ZimssaAPI.post(API.PARTNER.SIGNUP, {
    ...body,
  });

/**
 * 파트너 로그인
 * @param phone
 * @param authCode
 */
export const apiPartnerLogin = (
  phone: string,
  authCode: string
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.PARTNER.LOGIN, {
    phone,
    authCode,
  });

/**
 * 로그아웃
 */
export const apiPartnerLogout = (): Promise<IServerResponse> =>
  ZimssaAPI.get(API.PARTNER.LOGOUT);

/**
 * 서비스 상태 조회
 */
export const apiGetServiceProgress = (): Promise<IServerResponse> =>
  ZimssaAPI.get(API.SERVICE.PROGRESS);

/**
 * 서류 오류 정보 조회
 * @param serviceIdx
 * @param serviceType
 */
export const apiGetDocRejectInfo = (
  serviceIdx: number,
  serviceType: string
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.GET_DOC_REJECT, {
    serviceIdx,
    serviceType,
  });

export const apiDocReview = ({
  ...body
}: IDocReviewBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.DOC_REVIEW, {
    ...body,
  });

/**
 * 소형이사 서비스 임시저장
 * @param param0
 */
export const apiSmallMoveTempSave = ({
  ...body
}: IServiceSmallMoveTempBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.SMALLMOVE_TEMP_SAVE, {
    ...body,
  });

/**
 * 이사청소 서비스 임시저장
 * @param param0
 */
export const apiMoveCleaningTempSave = ({
  ...body
}: IServiceMoveCleaningTempBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.MOVECLEANING_TEMP_SAVE, {
    ...body,
  });

/**
 * 서비스 임시 저장데이터 호출
 * @param serviceType
 */
export const apiGetTempData = (
  serviceType: TServiceType
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.TEMP_DATA, {
    serviceType,
  });

/**
 * 소형이사 등록
 * @param param0
 */
export const apiSmallMoveRegister = ({
  ...body
}: IServiceSmallMoveRegisterBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.SMALLMOVE_REGISTER, {
    ...body,
  });

/**
 * 가정이사 서비스 임시저장
 * @param param0
 */
export const apiFamilyMoveTempSave = ({
  ...body
}: IServiceFamilyMoveTempBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.FAMILYMOVE_TEMP_SAVE, {
    ...body,
  });

/**
 * 가정이사 서비스 등록
 * @param param0
 */
export const apiFamilyMoveRegister = ({
  ...body
}: IServiceFamilyMoveRegisterBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.FAMILYMOVE_REGISTER, {
    ...body,
  });

/**
 * 이사청소 등록
 * @param param0
 */
export const apiMoveCleaningRegister = ({
  ...body
}: ISerMoveCleaningRegisterBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.MOVECLEANING_REGISTER, {
    ...body,
  });

/**
 * Auth 체크
 */
export const apiTokenCheck = (accessToken: string): Promise<IServerResponse> =>
  ZimssaAPI.get(API.PARTNER.STATUS, {
    headers: { AccessToken: accessToken },
  });

/**
 * 서비스 상태 조회
 * @param serviceType
 * @param serviceIdx
 */
export const apiGetServiceStatus = (
  serviceType: string,
  serviceIdx: number
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.STATUS, {
    serviceType,
    serviceIdx,
  });

export const apiServiceInterviewAnswer = (
  serviceType: string,
  serviceIdx: number
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.INTERVIEW_ANSWER, {
    serviceType,
    serviceIdx,
  });

export const apiUserProfileRegister = ({
  ...body
}: IUserProfileRegisterBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.USER.REGISTER_PROFILE, {
    ...body,
  });

export const apiGetUserProfile = (
  partnerUserIdx: number,
  serviceType: string,
  serviceIdx: number
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.USER.GET_PROFILE, {
    partnerUserIdx,
    serviceType,
    serviceIdx,
  });

export const apiServiceApproveChecked = (
  serviceType: string,
  serviceIdx: number
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.APPROVE_CHECKED, {
    serviceType,
    serviceIdx,
  });

export const apiGetServiceInfo = (
  serviceType: string,
  serviceIdx: number
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.INFO, {
    serviceType,
    serviceIdx,
  });

export const apiGetUserList = (
  serviceType: TServiceType,
  serviceIdx: number,
  page: number
): Promise<IServerResponse> =>
  ZimssaAPI.post(API.USER.LIST, {
    serviceType,
    serviceIdx,
    paging: {
      page,
    },
  });

export const apiPartnerUserRegister = ({
  ...body
}: IUserRegisterBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.USER.REGISTER, {
    ...body,
  });

export const apiPartnerUserModify = ({
  ...body
}: IUserModifyBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.USER.MODIFY, {
    ...body,
  });

export const apiGetPartnerSurveyContents = (): Promise<IServerResponse> =>
  ZimssaAPI.get(API.PARTNER.SURVEY_CONTENTS);

export const apiGetFeatureMaster = (
  serviceType: string
): Promise<IServerResponse> =>
  ZimssaAPI.get('/service/' + serviceType + '/offer-master');

export const apiGetServiceFeature = (
  serviceType: string,
  serviceIdx: number,
  searchType: string
): Promise<IServerResponse> =>
  ZimssaAPI.post('/service/offer', { serviceType, serviceIdx, searchType });

export const apiServiceFeatureRegister = ({
  ...body
}: IServiceFeatureRegisterBody): Promise<IServerResponse> =>
  ZimssaAPI.post(API.SERVICE.FEATURE_REGISTER, {
    ...body,
  });

export const apiAppDownLoad = (): Promise<IServerResponse> =>
  ZimssaAPI.get(API.APP_DOWN_LOAD);

export const apiGetPolicy = (): Promise<IServerResponse> =>
  ZimssaAPI.get(API.GET_POLICY);

export const apiGetMaintenance = (): Promise<IServerResponse> =>
  ZimssaAPI.get(process.env.REACT_APP_MAINTENANCE_URL!);
